import { notification } from "ant-design-vue";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { createManageExportCsv, createManageSelect, createPage } from "../../../../utils/page";
import { callGetHazLicenseReserveAndUse } from "../buy/buy.section";
import { callHazFull, createColumns } from "./stock-card.section";
import lodash from "lodash";
import moment from "moment";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/stockCard";
export const routerPrefix = "haz-mgt-stock-cards";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const onSearch = ({ page, state }) => {
    const quotaOperationKey = page.where.find(d => d.name === "quotaObjectiveKey").value;
    const refHazId = page.where.find(d => d.name === "refHazId").value;
    const refUserCompanyId = page.where.find(d => d.name === "refUserCompany")?.value;
    return callHazFull({ id: refHazId, quotaOperationKey, refUserCompanyId }).then(data => {

        const haz = data?.length > 1 ? data.find(d => !moment().isBefore(d.effectiveDate)) || data[0] : data[0];
        const approveCode = haz.approveCode;
        console.log("data1", data);
        console.log("haz", haz);
        callHazFull({ approveCode, quotaOperationKey, refUserCompanyId }).then(hazes => {
            state.refHaz = hazes?.length > 1 ? hazes.find(d => !moment().isBefore(d.effectiveDate)) || hazes[0] : hazes[0];
            console.log("hazes1", hazes);
            console.log("state.refHaz", state.refHaz);
            const hazLicenses = hazes.flatMap(d => d.hazLicenseDetails.map(d2 => d2.refHazLicense));
            if (!hazLicenses?.length) {
                notification["error"]({ message: i18n.global.t("views.stockCard.error.noHazLicense") });
                return null;
            }
            const where = page.where || [];
            const sort = page.sort || [];
            setIsLoading(true);
            window.onSearch?.({ page });
            // const refHazLicenseId = state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense?.id;
            const refHazLicenseIds = hazLicenses.map(d => d.id);
            const whereCustom = where.filter(d => d.name !== "refUserCompany").map(w => {
                if (w.name === "refHazId") {
                    return { ...w, name: "hazApproveCode", type: "String", operator: "=", value: approveCode };
                }
                return w;
            });
            return Promise.all([
                callSearch({
                    criteria: {
                        ...page,
                        data: [],
                        where: [
                            ...whereCustom,
                            // { name: "refHazLicenseId", type: "UUID", operator: "=", value: refHazLicenseId },
                            { name: "refHazLicenseId", type: "UUID", operator: "in", value: refHazLicenseIds },
                        ],
                        sort
                    }
                }),
                callGetHazLicenseReserveAndUse({ hazLicenseId: refHazLicenseIds })
            ]).then(arr => {
                const page = arr[0];
                const hazLicenseReserveUses = arr[1];
                state.page = { ...page, where, sort };
                if (state.refHaz?.hazLicenseDetails?.[0]?.refHazLicense) {
                    state.refHaz.hazLicenseDetails[0].refHazLicense.quantityReserve = lodash.sum(hazLicenseReserveUses.map(d => d.reserve || 0));
                    state.refHaz.hazLicenseDetails[0].refHazLicense.quantityUse = lodash.sum(hazLicenseReserveUses.map(d => d.use || 0));
                }
            }).finally(() => setIsLoading(false));
        })
    });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    const stateKey = `${routerPrefix}`;
    if (stateGroup[stateKey]) {
        return stateGroup[stateKey];
    }
    const state = {
        columns: createColumns({ props }),
        page: createPage({ options: { select: ["*"] } }),
        tableOptions: { search: { activeKey: "Search" } }
    };
    state.manages = [createManageSelect({ menuContext }), createManageExportCsv({ menuContext })];
    state.manageExtras = [];
    state.rowActions = [];
    return (stateGroup[stateKey] = state);
};

export const stateGroup = [];
